import * as React from "react";
import {IApplicationRootState} from "../../../applicationState";
import {
    clientPerformanceReportingAccess, cprPortfolioOverviewEnabled,
    currentPlan,
    hasAonTrustCompany,
    hasClientPortfolioAccess,
    hasPortfolioAccess,
    hasResearchAccess,
    insightsEnabled,
    sharedDocumentsEnabled
} from "../../../mainReducerMapSelectors";
import {connect} from "react-redux";
import {Home} from "./Home";
import {AtcHome} from "./AtcHome";
import {IPlanInfo} from "../../model/ClientsAndPlans.model";

export interface INewHomePropsFromStore {
    insightsEnabled: boolean;
    sharedDocumentsEnabled: boolean;
    hasResearchAccess: boolean;
    hasPortfolioAccess: boolean;
    clientPortfolioEnabled: boolean;
    aonTrustCompany: boolean;
    currentPlan: IPlanInfo;
    clientPerformanceReportingAccess: boolean;
    cprPortfolioOverviewEnabled: boolean;
}

export const NewHomePage: React.FunctionComponent<INewHomePropsFromStore> = (props) => {
    return props.aonTrustCompany
        ? <AtcHome sharedDocumentsEnabled={props.sharedDocumentsEnabled}/>
        : <Home insightsEnabled={props.insightsEnabled}
            sharedDocumentsEnabled={props.sharedDocumentsEnabled}
            hasResearchAccess={props.hasResearchAccess}
            hasPortfolioAccess={props.hasPortfolioAccess}
            clientPortfolioEnabled={props.clientPortfolioEnabled}
            currentPlan={props.currentPlan}
            clientPerformanceReportingAccess={props.clientPerformanceReportingAccess}
            cprPortfolioOverviewEnabled={props.cprPortfolioOverviewEnabled}/>;
};

export const mapStateToProps = (state: IApplicationRootState): INewHomePropsFromStore => {
    return {
        insightsEnabled: insightsEnabled(state),
        sharedDocumentsEnabled: sharedDocumentsEnabled(state),
        hasResearchAccess: hasResearchAccess(state),
        hasPortfolioAccess: hasPortfolioAccess(state),
        clientPortfolioEnabled: hasClientPortfolioAccess(state),
        aonTrustCompany: hasAonTrustCompany(state),
        currentPlan: currentPlan(state),
        clientPerformanceReportingAccess: clientPerformanceReportingAccess(state),
        cprPortfolioOverviewEnabled: cprPortfolioOverviewEnabled(state)
    };
};

const connectedComponent = connect<INewHomePropsFromStore>(mapStateToProps)(NewHomePage);

export default connectedComponent;